// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/apps/user_info/user_deletion_record_datatable" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsUserInfoUserDeletionRecordDatatable } from "./constants";
import type {
  AppsUserInfoUserDeletionRecordDatatableParams,
  AppsUserInfoUserDeletionRecordDatatableResult,
} from "./types";

export const getDataTableAppsUserInfoUserDeletionRecordDatatable = reactQueryTableFetcherAdapter(
  appsUserInfoUserDeletionRecordDatatable,
  (
    signal: AbortSignal,
    { appGroupId, query = {}, limit = 20, start = 0 }: AppsUserInfoUserDeletionRecordDatatableParams
  ): Promise<AppsUserInfoUserDeletionRecordDatatableResult> => {
    return fetch(
      "/apps/user_info/user_deletion_record_datatable",
      "GET",
      {
        limit,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
